export const getOptionalStringValue = (value?: string) => (value === '' ? undefined : value);
